@if (company) {
	<panel>
		<h1>{{ 'company.create-legal-case.create-debt-collection.header' | translate }}</h1>
		<edit-legal-case (close)="close()" />
	</panel>
	<panel width="420">
		<h1>{{ company.name }}</h1>
		<company-information [company]="company" />
		<list-contact [company]="company" />
	</panel>
}
